import { useQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import DEFAULT_OPERATIONS from "./product.gql";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveMegaMenu } from "../../../features/MegaMenu/MegaMenuSlice";
import { saveShowEnquireNow } from "../../../features/HomePage/HomePageSlice";

export const useProduct = () => {
  const { pathname } = useLocation();
  const [productSchemaData, setProductSchemaData] = useState("");
  const dispatch = useDispatch();
  const { getProductDetailQuery } = DEFAULT_OPERATIONS;
  const { ConfigData } = useSelector((state) => state.homePageSlice);

  const productUrlSuffix = useMemo(() => {
    if (ConfigData?.product_url_suffix) {
      return ConfigData.product_url_suffix;
    }
  }, [ConfigData]);

  const slug = pathname.split("/").pop();
  const urlKey = productUrlSuffix ? slug.replace(productUrlSuffix, "") : slug;

  const {
    error,
    loading,
    data: ProductData,
  } = useQuery(getProductDetailQuery, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    skip: !ConfigData,
    variables: {
      urlKey,
    },
  });

  const product = useMemo(() => {
    if (!ProductData) {
      return null;
    }
    const product = ProductData.products.items.find(
      (item) => item.url_key === urlKey
    );

    if (!product) {
      return "No Product";
    }

    return product;
  }, [ProductData, urlKey]);

  useEffect(() => {
    dispatch(saveMegaMenu(false));
  }, []);

  useEffect(() => {
    if (product?.show_enquire_now === 1) {
      dispatch(saveShowEnquireNow(true));
    } else {
      dispatch(saveShowEnquireNow(false));
    }
  }, [product]);

  return {
    error,
    loading,
    product,
    ConfigData,
    productSchemaData,
    setProductSchemaData,
  };
};
